/**
 * Utility functions for Aircraft Lifecycle management
 */

/**
 * Helper function to normalize strings for matching (remove common suffixes, normalize spaces)
 */
export const normalizeForMatching = (str) => {
  if (!str) return '';
  return str.trim()
    .toLowerCase()
    .replace(/\s+/g, ' ') // Normalize multiple spaces to single space
    .replace(/[^\w\s]/g, '') // Remove special characters except word chars and spaces
    .trim();
};

/**
 * Helper function to check if two strings match (exact or partial)
 */
export const stringsMatch = (str1, str2) => {
  const normalized1 = normalizeForMatching(str1);
  const normalized2 = normalizeForMatching(str2);
  
  // Exact match
  if (normalized1 === normalized2) return true;
  
  // Check if one contains the other (for cases like "Gulfstream" matching "Gulfstream Aerospace")
  if (normalized1.includes(normalized2) || normalized2.includes(normalized1)) {
    // Only consider it a match if the shorter string is at least 3 characters
    const shorter = normalized1.length < normalized2.length ? normalized1 : normalized2;
    return shorter.length >= 3;
  }
  
  return false;
};

/**
 * Format dependencies for display in error messages
 */
export const formatDependencies = (dependencies) => {
  if (!dependencies || !Array.isArray(dependencies)) return '';
  
  let message = '\n\nDependencies found:\n';
  message += '='.repeat(50) + '\n';
  
  dependencies.forEach((dep, index) => {
    message += `\n${index + 1}. ${dep.type}:\n`;
    message += `   Total: ${dep.total || 0} (Active: ${dep.activeCount || 0}, Archived: ${dep.archivedCount || 0})\n`;
    
    if (dep.items && dep.items.length > 0) {
      message += `   Details (showing first ${Math.min(dep.items.length, 10)}):\n`;
      dep.items.forEach((item, itemIndex) => {
        const itemDetails = Object.entries(item)
          .map(([key, value]) => `${key}: ${value}`)
          .join(', ');
        message += `     - ${itemDetails}\n`;
      });
      if (dep.total > 10) {
        message += `   ... and ${dep.total - 10} more\n`;
      }
    }
  });
  
  message += '\n' + '='.repeat(50);
  message += '\n\nPlease remove all dependencies before attempting to delete.';
  
  return message;
};

/**
 * Get status color for status chips
 */
export const getStatusColor = (status) => {
  switch (status) {
    case 'APPROVED': return 'success';
    case 'SUBMITTED': return 'warning';
    case 'REJECTED': return 'error';
    default: return 'default';
  }
};
